"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Dialog/index"), exports);
var index_1 = require("./components/Dialog/index");
exports.default = index_1.Dialog;
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Dialog.js
// module id = 914
// module chunks = 0